<div class="footerbottom">
  <div class="footercol">
    <div class="socialicon"></div>
    <div class="bottomenuitems">
      <ul>
        <li><a rel="nofollow" href="https://metrics.aspose.ai">{{'footer.home' | translate}}</a></li>
        <li class="sep1">|</li>

        <li>
          <a rel="nofollow" href="https://websites.aspose.com/">{{'footer.websites' | translate}}</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="footer2bar">
    <div class="footer2col">
      <div class="footer2text">
        <p>{{ "footer.footer-2-text" | translate : { currentYear } }}</p>
      </div>
      <div class="footer2anchor">
        <span class="footer2bottom">
          <a rel="nofollow" href="/legals/">{{
            "footer.privacy" | translate
          }}</a>
          <span class="sep1">|</span>
          <a rel="nofollow" href="/legals/tos/">{{
            "footer.terms" | translate
          }}</a>
          <span class="sep1">|</span>
          <a rel="nofollow" href="/contact/">{{
            "footer.contact" | translate
          }}</a>
        </span>
      </div>
    </div>
  </div>
</div>
